import { render, staticRenderFns } from "./ListCommunicationTemplates.vue?vue&type=template&id=77f154d1&scoped=true&"
import script from "./ListCommunicationTemplates.vue?vue&type=script&lang=js&"
export * from "./ListCommunicationTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ListCommunicationTemplates.vue?vue&type=style&index=0&id=77f154d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f154d1",
  null
  
)

export default component.exports